import baseAPI from '@/api/base';
import { GetAdminDashboardStats, GetDashboardStats, GetEmployeeDashboardStats } from '@/dtos/stats.dto';
import {
  GET_ADMIN_DASHBOARD_STATS_URL,
  GET_DASHBOARD_STATS_URL,
  GET_EMPLOYEE_DASHBOARD_STATS_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Stats {
  static getDashboardStats = async (dashboardStats: GetDashboardStats): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_DASHBOARD_STATS_URL, {
      params: dashboardStats,
    });
    return response;
  };

  static getEmployeeDashboardStats = async (params: GetEmployeeDashboardStats): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_DASHBOARD_STATS_URL, {
      params,
    });
    return response;
  };

  static getAdminDashboardStats = async (params: GetAdminDashboardStats): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_ADMIN_DASHBOARD_STATS_URL, {
      params,
    });
    return response;
  };
}

export default Stats;
